module.exports = __webpack_public_path__ + "img/codet.c235fd79.png";